import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { IndustryItem } from '~types/company';

import QueryKeys from '../queryKeys';

export default function useIndustries() {
  return useQuery<IndustryItem[]>([QueryKeys.industries], () => fetcher('/api/industries'));
}
